export default __webpack_public_path__ + "static/media/pexels-cottonbro-7578799.5e688019.jpg";